import { useState } from 'react'
import style from './index.module.scss'
import logoNew2 from '@/assets/images/logoNew2.png'
import HeaderAction from '../headeraction'
import LoginForm from '../loginForm'

export default function YundingLogin({
  handleMfaLogin,
  mfaVisible
}: {
  handleMfaLogin: (params: any) => void
  mfaVisible: boolean
}) {
  return (
    <div className={style.yundingLogin}>
      <div className={style.header}>
        <img className={style.logo} src={logoNew2} alt='' />
        <HeaderAction customizationEnable={false} />
      </div>
      <LoginForm
        handleMfaLogin={handleMfaLogin}
        mfaVisible={mfaVisible}
      />
    </div>
  )
}
